import axios from 'axios';
import {api} from "#constants/appUrl";

const token = sessionStorage.getItem("token");
const url = api + 'roles';
const headers = {
    'accept': 'application/json',
    'Authorization': 'Bearer ' + token,
}

const getAllRoles = async ({commit}) => {
    try {
        let response = (await axios.get(url, {headers})).data;
        commit('setRoles', response.data);
    } catch (error) {
    }
}

const findRoleById = async ({commit}, id) => {
    try {
        let response = (await axios.get(url + '/find-by-id/' + id, {headers})).data;
        commit('setSelectedRole', response);
    } catch (error) {
    }
}

const setSelectedRole = async ({commit}, obj) => {
    commit('setSelectedRole', obj)
}

const getPermissionsOfRoleId = async ({commit}, obj) => {
    try {
        let response = (await axios.get(url + '/get-permissions/by-role-id/' + obj.role_id,
            {headers: headers, params: obj.params})).data;
        commit('setPermissions', response.data);
        commit('setPermissionsPages', response.meta);
    } catch (error) {
    }
}

const getAllPermissions = async ({commit}, role_id) => {
    try {
        let response = (await axios.get(api + 'permission' + '/get-all-permissions/' + role_id, {headers})).data;
        commit('setAllPermissions', response);
    } catch (error) {
    }
}

const storeRoleHasPermission = ({commit}, obj) => {
    let data = {
        role_id: obj.role_id,
        permission_id: obj.permission_id
    }
    axios.post(api + 'role-has-permission/store', data, {headers}).then(response => {
        return response.data;
    }).catch(error => {
        return false;
    });
}

const removePermissionOfRole = async ({commit}, obj) => {
    try {
        let data = {
            role_id: obj.role_id,
            permission_id: obj.permission_id
        }
        let response = (await axios.post(api + 'role-has-permission/remove', data, {headers})).data;
    } catch (error) {
    }

}

const syncRoles = async ({commit}, obj) => {
    try {
        return (await axios.post(url + '/sync-roles', obj, {headers})).data;

    } catch (error) {
    }
}

export default {
    getAllRoles,
    setSelectedRole,
    getPermissionsOfRoleId,
    findRoleById,
    getAllPermissions,
    storeRoleHasPermission,
    removePermissionOfRole,
    syncRoles
}
